module.exports = __webpack_public_path__ + "img/cowmilk.c8927c04.jpg";